import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';
export default class JokoakSidebarMenu extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.isOpen = false;
  }
  view() {
    const currentPath = m.route.get() || '';
    const season = this.attrs.season || m.route.param('season') || '2025-2026';
    const clubSlug = app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
    const isReal = clubSlug === 'real-sociedad';
    const gorbeaUrl = isReal ? 'pastor-del-txindoki' : 'pastor-del-gorbea';
    const gorbeaLabel = isReal ? 'Txindoki' : 'Gorbea';

    // Check which section we are in
    const isBolilla = currentPath.includes('/la-bolilla');
    const isRatings = currentPath.includes("/valoracion-".concat(clubSlug));
    const is11Aldeanos = currentPath.includes('/11-aldeanos') || currentPath.includes('/clasificacion-11-aldeanos');
    const menuItems = [{
      label: '🔮 Votar Bolilla',
      href: "/la-bolilla/".concat(season, "/votar"),
      isActive: isBolilla && currentPath.includes('/votar'),
      isHeaderLink: isBolilla
    }, {
      label: '🏆 Clasificación Bolilla',
      href: "/la-bolilla/".concat(season, "/clasificacion"),
      isActive: isBolilla && currentPath.includes('/clasificacion'),
      isHeaderLink: isBolilla
    }, {
      label: "\u26F0\uFE0F Pronosticar Pastor ".concat(gorbeaLabel),
      href: "/".concat(gorbeaUrl, "/").concat(season, "/votar"),
      isActive: currentPath.includes("/".concat(gorbeaUrl)) && currentPath.includes('/votar'),
      isHeaderLink: currentPath.includes("/".concat(gorbeaUrl))
    }, {
      label: "\uD83C\uDFC6 Clasificaci\xF3n ".concat(gorbeaLabel),
      href: "/".concat(gorbeaUrl, "/").concat(season, "/clasificacion"),
      isActive: currentPath.includes("/".concat(gorbeaUrl)) && currentPath.includes('/clasificacion'),
      isHeaderLink: currentPath.includes("/".concat(gorbeaUrl))
    }, {
      label: '🏃‍♂️ Valorar Jugadores',
      href: "/valoracion-".concat(clubSlug, "/").concat(season, "/valorar"),
      isActive: isRatings && currentPath.includes('/valorar'),
      isHeaderLink: isRatings
    }, {
      label: '📊 Clasificación Jugadores',
      href: "/valoracion-".concat(clubSlug, "/").concat(season, "/clasificacion"),
      isActive: isRatings && currentPath.includes('/clasificacion'),
      isHeaderLink: isRatings
    }, {
      label: '🛡️ Alinear 11 Aldeanos',
      href: "/11-aldeanos/".concat(season, "/pronosticar"),
      isActive: is11Aldeanos && currentPath.includes('/pronosticar'),
      isHeaderLink: is11Aldeanos
    }, {
      label: '🏆 Clasificación 11 Aldeanos',
      href: "/11-aldeanos/".concat(season, "/clasificacion"),
      isActive: is11Aldeanos && currentPath.includes('/clasificacion'),
      isHeaderLink: is11Aldeanos
    }];
    return m("div", {
      className: "JokoakSidebarMenu-Wrapper"
    }, m("div", {
      className: "JokoakSidebarMenu-Desktop"
    }, m("h3", {
      className: "JokoakSidebarMenu-Title"
    }, "Navegaci\xF3n de Juegos"), m("ul", {
      className: "JokoakSidebarMenu-List"
    }, menuItems.map(item => {
      const linkClass = "JokoakSidebarMenu-Link ".concat(item.isActive ? 'is-active' : '');
      return m("li", {
        key: item.label
      }, m("a", {
        href: item.href,
        className: linkClass,
        onclick: e => {
          // Handle smooth scroll if on the same page
          const hashIndex = item.href.indexOf('#');
          if (hashIndex !== -1) {
            const pathWithoutHash = item.href.substring(0, hashIndex);
            const currentPathWithoutHash = currentPath.split('#')[0];
            if (pathWithoutHash === currentPathWithoutHash) {
              e.preventDefault();
              const targetId = item.href.substring(hashIndex + 1);
              const targetElement = document.getElementById(targetId);
              if (targetElement) {
                targetElement.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                });
                m.route.set(item.href);
              }
            }
          }
        }
      }, item.label));
    }))), m("div", {
      className: "JokoakMobile-FloatingTrigger"
    }, m("button", {
      className: "Button JokoakMobile-FloatingPill",
      onclick: () => {
        this.isOpen = true;
        m.redraw();
      }
    }, m("i", {
      className: "fas fa-compass",
      style: "margin-right: 8px;"
    }), "Men\xFA de Juegos")), this.isOpen && m("div", {
      className: "JokoakMobile-Overlay",
      onclick: () => {
        this.isOpen = false;
        m.redraw();
      }
    }, m("div", {
      className: "JokoakMobile-BottomSheet",
      onclick: e => e.stopPropagation()
    }, m("div", {
      className: "JokoakMobile-BottomSheet-Header"
    }, m("span", null, "Men\xFA de Juegos"), m("button", {
      className: "Button Button--icon Button--link close-btn",
      onclick: () => {
        this.isOpen = false;
        m.redraw();
      }
    }, m("i", {
      className: "fas fa-times"
    }))), m("div", {
      className: "JokoakMobile-BottomSheet-Body"
    }, m("ul", {
      className: "JokoakMobile-BottomSheet-List"
    }, menuItems.map(item => {
      const linkClass = "JokoakMobile-BottomSheet-Link ".concat(item.isActive ? 'is-active' : '');
      return m("li", {
        key: item.label
      }, m("a", {
        href: item.href,
        className: linkClass,
        onclick: e => {
          this.isOpen = false;
          const hashIndex = item.href.indexOf('#');
          if (hashIndex !== -1) {
            const pathWithoutHash = item.href.substring(0, hashIndex);
            const currentPathWithoutHash = currentPath.split('#')[0];
            if (pathWithoutHash === currentPathWithoutHash) {
              e.preventDefault();
              const targetId = item.href.substring(hashIndex + 1);
              const targetElement = document.getElementById(targetId);
              if (targetElement) {
                setTimeout(() => {
                  targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                  });
                }, 100);
                m.route.set(item.href);
              }
            }
          }
          m.redraw();
        }
      }, item.label));
    }))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/aurrera-jokoak/JokoakSidebarMenu', JokoakSidebarMenu);